<template>
  <kt-row>
    <div class="col col-sm-6 col-lg-4 col-xl-3" v-bind:key="gateway.index" v-for="gateway in gateways">
      <kt-panel>
        <kt-panel-body class="p-0 pt-4">
          <kt-panel-header-label class="text-center">
            <kt-row>
              <kt-col lg="11" md="11" sm="11" class="pl-5">
                <img :src="gateway.logo" class="kt-badge kt-badge--xl"/>
                <kt-panel-header-title class="mt-3 text-dark">
                  {{ gateway.title }}
                </kt-panel-header-title>
                <span :class="'kt-badge--'+variant(gateway.status)" class="kt-badge kt-badge--dot mr-1"></span>
                <span :class="'text-'+variant(gateway.status)">
                                {{ statusStr(gateway.status) }}
                                <i
                                    v-if="gateway.rejection_reason && gateway.status == gatewayStatus.REJECTED"
                                    class="fa fa-exclamation-triangle"
                                    style="color: orangered!important; cursor: pointer"
                                    aria-hidden="true"
                                    data-toggle="tooltip"
                                    :title="gateway.rejection_reason"
                                ></i>
                            </span>

                <span v-if="gateway.response_rejection_reason" class="position-absolute"
                      style="cursor: pointer; color: orangered" data-toggle="dropdown">
                                <i class="fa fa-info-circle" aria-hidden="true" style="font-size: 1.6em;"></i>
                            </span>

                <ul v-if="gateway.response_rejection_reason" class="dropdown-menu">
                  <div class="dropdown-header">{{ $t('gateway.btn.rejection_reason') }}</div>
                  <li v-bind:key="reason.index" v-for="reason in gateway.response_rejection_reason" class="text-center">
                    {{ reason.fieldName }} {{ ' : ' }} {{ reason.codeExceptionValue }}
                  </li>
                  <!--                        <li class="divider"></li>-->
                </ul>

                <br>
                <span v-if="gateway.status"
                      :class="'d-block w-75 mx-auto mt-3 badge badge-' + typeVariant(gateway.gateway_type)">
                                {{ $t('label.gateway_type') + ": " + gatewayType(gateway.gateway_type) }}
                            </span>
                <span v-if="gateway.status" class="d-block w-75 mx-auto mt-3 badge badge-secondary">
                                {{ $t('label.gateway_id') + ": " + gateway.sequence }}
                            </span>
              </kt-col>
              <kt-col lg="1" md="1" sm="1">
                <kt-row>
                  <kt-col lg="12" md="12" sm="12">
                    <router-link v-if="gateway.status === gatewayStatus.ACTIVE &&
                                        gateway.gateway_type === gatewayTypes.PARDAKHTYARI"
                                 class="kt-nav__link" :to="getLink(gateway.id)"
                    >
                      <h5>
                        <i
                            class="fa fa-certificate"
                            style="float: left"
                            aria-hidden="true"
                            :title="$t('panel.profile.nav.namad')"
                        ></i>
                      </h5>
                    </router-link>
                  </kt-col>
                  <kt-col lg="12" md="12" sm="12" class="show-report-status ">
                    <router-link v-if="gateway.status === gatewayStatus.ACTIVE &&
                                        gateway.show_psp_report_to_user === 1"
                                 class="kt-nav__link pl-3 mr-2" :to="getReportLink(gateway.id)"
                    >
                      <h5>
                        <i
                            class="fa fa-dollar-sign"
                            style="float: left"
                            aria-hidden="true"
                            :title="$t('label.psp-transactions-report')"
                        ></i>
                      </h5>
                    </router-link>
                  </kt-col>
                </kt-row>
              </kt-col>
            </kt-row>
          </kt-panel-header-label>
        </kt-panel-body>
        <kt-row>
          <kt-col>
            <kt-panel-footer class="p-3 pr-1 text-center" style="padding-left: 0!important">
              <router-link class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                           :to="updateUrl(gateway.gateway_type) + gateway.id">
                {{ $t('btn.edit') }}
              </router-link>
            </kt-panel-footer>
          </kt-col>
          <kt-col>
            <kt-panel-footer class="p-3 pl-1 text-center" style="padding-right: 0!important">
              <router-link class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                           :to="'gateways/' + gateway.id + '/allotment'">
                {{ $t('btn.allotment') }}
              </router-link>
            </kt-panel-footer>
          </kt-col>
        </kt-row>

      </kt-panel>
    </div>
  </kt-row>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {gatewayStatus, gatewayStatusStr, gatewayVariant} from '@/constants/gatewayStatus'
import {gatewayTypeStr, gatewayTypeVariant, gatewayTypeUpdateUrl, gatewayTypes} from '@/constants/gatewayTypes'
import $ from 'jquery'

export default {
  data() {
    return {
      gatewayStatus: gatewayStatus,
      gatewayTypes: gatewayTypes
    }
  },
  methods: {
    ...mapActions('gateway', [
      'fetch'
    ]),
    variant(status) {
      return gatewayVariant(status)
    },
    typeVariant(type) {
      return gatewayTypeVariant(type)
    },
    statusStr(status) {
      return gatewayStatusStr.get(status)
    },
    gatewayType(type) {
      return gatewayTypeStr.get(type)
    },
    updateUrl(type) {
      return gatewayTypeUpdateUrl(type)
    },
    getLink(hashid) {
      return "/profile/namad/" + hashid
    },

    getReportLink(hashid) {
      return "/gateways/transactions-report/" + hashid
    }

  },
  mounted() {
    this.fetch()
  },
  computed: {
    ...mapGetters('gateway', [
      'gateways'
    ]),
  },

}
</script>

<style>
.show-report-status {
  margin-top: -25%;
}
</style>